import DiscountViewSFC from "./DiscountView.vue";
export const DiscountView = DiscountViewSFC;
